define(function(require) {


    const modalHtml = '<div class="modal fade" id="GuidedTour_modal" tabindex="-1" role="dialog" aria-labelledby="Visite guidée de la carte" aria-hidden="true">' +
                                '<div class="modal-dialog modal-lg">' +
                                    '<div class="modal-content">' +
                                        '<div class="modal-header">' +
                                            '<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
                                            '<h4 class="modal-title">Visite guidée de l\'atlas de la défavorisation</h4>' +
                                        '</div>' +
                                        '<div class="modal-body">' +
                                            '<div class="container-fluid">' +
                                                '<div class="row">' +
                                                    '<h5><strong>L\'atlas est composé des sections suivantes :</strong><br><small><em>Veuillez cliquer sur une des sections ci-dessous pour lancer la visite guidée.</em></small></h5>' +
                                                '</div>' +
                                            '<div class="row vertical-align">' +
                                                '<dl class="dl-horizontal">' +
                                                    '<dt><button type="button" value="bandeau" class="btn btn-default btn-block startTour" data-dismiss="modal">L\'entête</button></dt>' +
                                                    '<dd>L\'entête, en bleu, comprend le titre de la carte, le menu déroulant permettant de sélectionner une thématique ainsi que les boutons pour accéder à la zone de téléchargement et à l\'aide.</dd>' +
                                                '</dl>' +
                                            '</div>' +
                                            '<div class="row">' +
                                                '<dl class="dl-horizontal">' +
                                                    '<dt><button type="button" value="carte" class="btn btn-default btn-block startTour" data-dismiss="modal">La carte</button></dt>' +
                                                    '<dd>La carte constitue l\'élément central où sont affichées les différentes thématiques. Des outils cartographiques sont également disponibles pour naviguer et pour sélectionner ou interroger des objets géographiques.</dd>' +
                                                '</dl>' +
                                            '</div>' +
                                            '<div class="row">' +
                                                '<dl class="dl-horizontal">' +
                                                    '<dt>' +
                                                        '<div class="dropdown">' +
                                                            '<button type="button" class="btn btn-default btn-block dropdown-toggle" data-toggle="dropdown" aria-expanded="false">Le panneau latéral <span class="caret"></span></button>' +
                                                            '<ul class="dropdown-menu" style="position:relative; border:0;" role="menu">' +
                                                                '<li><button type="button" value="panelConstat" class="btn btn-default btn-xs btn-block startTour" role="menuitem" data-dismiss="modal">Le constat</button></li>' +
                                                                '<li><button type="button" value="panelRecherche" class="btn btn-default btn-xs btn-block startTour" role="menuitem" data-dismiss="modal">L\'outil de recherche</button></li>' +
                                                                '<li><button type="button" value="panelGraphique" class="btn btn-default btn-xs btn-block startTour" role="menuitem" data-dismiss="modal">Les graphiques</button></li>' +
                                                                '<li><button type="button" value="panelInfo" class="btn btn-default btn-xs btn-block startTour" role="menuitem" data-dismiss="modal">L\'outil Info</button></li>' +
                                                                '<li><button type="button" value="panelLegende" class="btn btn-default btn-xs btn-block startTour" role="menuitem" data-dismiss="modal">La légende</button></li>' +
                                                            '</ul>' +
                                                        '</div>' +
                                                    '</dt>' +
                                                    '<dd>Le panneau latéral est composé de différentes sections dynamiques qui se mettent à jour automatiquement en fonction de la thématique active et des objets sélectionnés dans la carte. Ces sections sont : le constat, l\'outil de recherche qui permet de localiser un objet géographique en particulier, la vue en graphique, l\'outil Info, et la légende de la carte.</dd>' +
                                                '</dl>' +
                                            '</div>' +
                                            '<div class="row">' +
                                                '<dl class="dl-horizontal">' +
                                                    '<dt><button type="button" value="panelDonnees" class="btn btn-default btn-block startTour" data-dismiss="modal">Les données</button></dt>' +
                                                    '<dd>Les tableaux de données sont situés à l\'intérieur du panneau inférieur. Le premier onglet, nommé <em>Données</em>, permet de consulter les données associées à tous les objets géographiques de la carte en fonction de la thématique active. Le deuxième onglet, <em>Sélection</em>, permet d\'afficher les données des objets géographiques sélectionnés en fonction de la thématique active.</dd>' +
                                                '</dl>' +
                                            '</div>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>' +
                            '</div>' +
                        '</div>';

    var config = {
        "bandeau": {
                steps: [{
                    title: "L'entête",
                    element: ".cv-mapTitle",
                    content: "Titre de l'atlas",
                    placement: "bottom"
                }, {
                    title: "L'entête",
                    element: ".cv-btnThemeSetList",
                    content: "Titre de la thématique active",
                    placement: "bottom"
                }, {
                    title: "L'entête",
                    element: ".cv-btnPrint",
                    content: "Outil d'impression",
                    placement: "bottom"
                }, {
                    title: "L'entête",
                    element: ".cv-btnHelp",
                    content: "Accès à la visite guidée et à la documentation",
                    animation: false,
                    placement: "bottom"
                }, {
                    title: "L'entête",
                    element: ".cv-btnThemeSetList",
                    content: "Cliquer pour ouvrir l'arborescence et choisir une thématique",
                    placement: "right",
                    onShown: function(tour) {
                        $(this.element).click();
                    },
                    onPrev: function(tour) {
                        $(".cv-header-themesetListPopup").parent().css({"display": "none"});
                    }
                }, {
                    title: "L'entête",
                    element: "#-kendoPopupWindow-CvThemeSetListTreeView-treeView_tv_active",
                    content: "La thématique active est surlignée en bleu",
                    placement: "left",
                    onShow: function(tour) {
                        $(".cv-header-themesetListPopup").parent().css({"display": ""});
                    }
                }, {
                    title: "L'entête",
                    element: ".cv-header-themesetListPopup",
                    content: "Naviguer à l'intérieur des arborescences pour afficher les différentes thématiques disponibles, puis cliquer sur celle à afficher dans la carte.",
                    placement: "left",
                    onShow: function(tour) {
                        $(".cv-header-themesetListPopup").parent().css({"display": ""});
                    }
                }, {
                    title: 'L\'entête',
                    element: '#BtnLater',
                    content: 'Possibilité de choisir l\'année du recensement pour la thématique sélectionnée',
                    animation: false,
                    placement: 'bottom',
                    duration: 8000,
                }],
                onTourEnd: function() {
                    $(".cv-header-themesetListPopup").parent().css({"display": "none"});
                }
            },
            "carte": {
                steps: [{
                    title: "La carte",
                    element: ".cv-initialExtentTool",
                    content: "Vue initiale : Zoom à la vue initiale",
                    placement: "bottom",
                    onShown: function(tour) {
                        $(this.element).click();
                    }
                }, {
                    title: "La carte",
                    element: ".cv-zoomInTool",
                    content: "Zoom avant : Dessiner un rectangle sur la carte pour afficher une vue plus détaillée",
                    placement: "bottom",
                    onShown: function(tour) {
                        $(this.element).click();
                    }
                }, {
                    title: "La carte",
                    element: ".cv-zoomOutTool",
                    content: "Zoom arrière : Cliquer sur la carte pour afficher une vue moins détaillée",
                    placement: "bottom",
                    onShown: function(tour) {
                        $(this.element).click();
                    }
                }, {
                    title: "La carte",
                    element: ".cv-infoPanTool",
                    content: "Info et Recentrer : Cliquer sur la carte pour visualiser l'information associée à un objet de la carte ou déplacer la carte pour recentrer",
                    placement: "bottom",
                    onShown: function(tour) {
                        $(this.element).click();
                    }
                }, {
                    title: "La carte",
                    element: ".BtnSelectionMenuToolArrow",
                    content: "Ouvrir le menu de sélection",
                    placement: "bottom",
                    onShown: function(tour) {
                        $(this.element).click();
                        $(".cv-popup.cv-selectionMenuToolPopup").parent().css("display", "");
                    }
                }, {
                    title: "La carte",
                    element: ".cv-selectionMenuToolLayersList .k-input",
                    content: "Définir la couche dont les entités seront sélectionnables",
                    placement: "right",
                    onPrev: function(tour) {
                        $(".cv-popup.cv-selectionMenuToolPopup").parent().css("display", "none");
                    },
                    onShow: function(tour) {
                        $(".cv-popup.cv-selectionMenuToolPopup").parent().css("display", "");
                    }
                }, {
                    title: "La carte",
                    element: ".cv-simpleSelectionTool",
                    content: "Sélection : Sélectionner les entités géographiques en cliquant sur la carte (utiliser les touches Maj et Ctrl pour faire une sélection multiple)",
                    placement: "bottom",
                    onShow: function(tour) {
                        $(".cv-popup.cv-selectionMenuToolPopup").parent().css("display", "");
                    }
                }, {
                    title: "La carte",
                    element: ".cv-circularSelectionTool",
                    content: "Sélection circulaire : Dessiner un cercle sur la carte pour sélectionner des entités géographiques (utiliser les touches Maj et Ctrl pour faire une sélection multiple)",
                    placement: "bottom",
                    onShow: function(tour) {
                        $(".cv-popup.cv-selectionMenuToolPopup").parent().css("display", "");
                    }
                }, {
                    title: "La carte",
                    element: ".cv-rectangularSelectionTool",
                    content: "Sélection rectangulaire : Dessiner un rectangle sur la carte pour sélectionner des entités géographiques (utiliser les touches Maj et Ctrl pour faire une sélection multiple)",
                    placement: "bottom",
                    onShow: function(tour) {
                        $(".cv-popup.cv-selectionMenuToolPopup").parent().css("display", "");
                    }
                }, {
                    title: "La carte",
                    element: ".cv-polygonalSelectionTool",
                    content: "Sélection polygonale : Dessiner un polygone sur la carte pour sélectionner des entités géographiques (double-cliquer pour fermer) (utiliser les touches Maj et Ctrl pour faire une sélection multiple)",
                    placement: "bottom",
                    onShow: function(tour) {
                        $(".cv-popup.cv-selectionMenuToolPopup").parent().css("display", "");
                    }
                }, {
                    title: "La carte",
                    element: ".cv-selectionMenuToolPopup #-chkEnabled-checkbox",
                    content: "Intersection spatiale : Sélectionner des entités géographiques en fonction de leur localisation par rapport à d'autres entités.",
                    placement: "bottom",
                    onShow: function(tour) {
                        $(".cv-popup.cv-selectionMenuToolPopup").parent().css("display", "");
                    }
                }, {
                    title: "La carte",
                    element: ".cv-unselectAllTool",
                    content: "Désélectionner tout : Désélectionner toutes les entités géographiques",
                    placement: "bottom",
                    onPrev: function(tour) {
                        $(".cv-popup.cv-selectionMenuToolPopup").parent().css("display", "");
                    },
                    onShow: function(tour) {
                        $(".cv-popup.cv-selectionMenuToolPopup").parent().css("display", "none");
                    },
                    onShown: function(tour) {
                        $(this.element).click();
                    }
                }, {
                    title: "La carte",
                    element: ".cv-hyperlinkTool",
                    content: "Hyperlien : Ouvrir un hyperlien associé à un objet de la carte",
                    placement: "bottom",
                    onShown: function(tour) {
                        $(this.element).click();
                    }
                }, {
                    title: "La carte",
                    element: "#forageBtn",
                    content: "Forage : Filtrer la thématique active en fonction d'un centre de services scolaire. (utiliser les touches Maj et Ctrl pour faire une sélection multiple ou sélectionner directement à l'aide de la liste)",
                    placement: "bottom",
                    onShown: function(tour) {
                        $(this.element).click();
                    }
                }, {
                    title: "La carte",
                    element: "#forageArrow",
                    content: "Ouvrir le menu de l'outil de forage",
                    placement: "bottom",
                    onShown: function(tour) {
                        $(this.element).click();
                    }
                }, {
                    title: "La carte",
                    element: "#forageDDContainer .k-input",
                    content: "Définir la couche sur laquelle effectuée le forage",
                    placement: "right",
                    onShown: function(tour) {
                        $(this.element).click();
                    },
                    onHide: function(tour) {
                        $(this.element).click();
                    }
                }, {
                    title: "La carte",
                    element: "#forageSearchInput",
                    content: "Chercher un territoire dans la liste",
                    placement: "right",
                }, {
                    title: "La carte",
                    element: "#forageGrid",
                    content: "Liste des territoires disponibles : cliquer sur un élément de la liste",
                    placement: "right",
                    onShown: function(tour) {
                        $("#forageGrid").data("kendoGrid").select("tr:eq(0)");
                    }
                },  {
                    title: "La carte",
                    element: "#forageCancelBtn",
                    content: "Annuler le forage: afficher l'ensemble des données",
                    placement: "right",
                    onShown: function(tour) {
                        $(this.element).click();
                    }
                }, {
                    title: "La carte",
                    element: ".cv-zoomBar button:eq(0)",
                    content: "Applique un zoom à partir du centre de la carte pour afficher une vue plus détaillée",
                    placement: "right",
                    onShown: function(tour) {
                        $(this.element).click();
                    }
                }, {
                    title: "La carte",
                    element: ".cv-zoomBar button:eq(1)",
                    content: "Applique un zoom à partir du centre de la carte pour afficher une vue moins détaillée",
                    placement: "right",
                    onShown: function(tour) {
                        $(this.element).click();
                    }
                }, {
                    title: "La carte",
                    element: ".cv-exportTool",
                    content: "Exporter une image de la carte",
                    placement: "bottom"
                }, {
                    title: "La carte",
                    element: ".cv-scaleBar",
                    content: "Échelles graphique et numérique de la carte",
                    placement: "right",
                    duration: 6000
                }],
                onTourStart: function() {
                    $(".cv-toolbar, .cv-zoomBar, .cv-exportTool").css({
                        "opacity": "1",
                        "transition": "all 0 ease 0"
                    });
                },
                onTourEnd: function() {
                    $(".cv-popup.cv-selectionMenuToolPopup").parent().css("display", "none");
                    $(".cv-toolbar, .cv-zoomBar, .cv-exportTool").css({
                        "opacity": "",
                        "transition": ""
                    });
                    $(".cv-infoPanTool").click();
                }
            },
            "panelConstat": {
                steps: [{
                    title: "Le constat",
                    element: "#Constat_panel_btn",
                    content: "Constat: Afficher le constat de la thématique active",
                    placement: "left",
                    onShown: function(tour) {
                        var map = window.cartovista.externalInterface.map;
                        window.cartovista.getUIController(map).findInstance("Constat_panel").activate();
                    }
                }, {
                    title: "Le constat",
                    element: "#Constat_panel",
                    content: "Cette section contient une brève description de la thématique sélectionnée",
                    placement: "left",
                    duration: 6000
                }]
            },
            "panelRecherche": {
                steps: [{
                    title: "Recherche",
                    element: "#SearchView_panel_btn",
                    content: "<strong>Recherche</strong> : Faire une recherche à partir des couches de la carte",
                    placement: "left",
                    onShown: function(tour) {
                        var map = window.cartovista.externalInterface.map;
                        window.cartovista.getUIController(map).findInstance("SearchView_panel").activate();
                    }
                }, {
                    title: "Recherche",
                    element: "#searchView_input",
                    content: "Taper un élément de recherche (ex. : un code postal)",
                    placement: "left"
                }, {
                    title: "Recherche",
                    element: "#searchView_grid",
                    content: "<strong>Résultats de la recherche</strong> : cliquer sur un élément de la liste pour centrer la carte sur l'entité",
                    placement: "left",
                    duration: 6000,
                }]
            },
            "panelGraphique": {
                steps: [{
                    title: "Graphiques",
                    element: ".cv-btnToggleChartView",
                    content: "Vue en graphique : pour afficher les données sous forme graphique",
                    placement: "left",
                    onShown: function(tour) {
                        var map = window.cartovista.externalInterface.map;
                        window.cartovista.getUIController(map).findInstance("chartView").activate();
                    }
                }, {
                    title: "Graphiques",
                    element: ".cv-chartView .k-dropdown-wrap.k-state-default:visible",
                    content: "Titre du graphique",
                    placement: "left",
                    onShown: function(tour) {
                        $(this.element).click();
                    },
                    onHide: function(tour) {
                        $(this.element).click();
                    }
                }, {
                    title: "Graphiques",
                    element: ".cv-chartView",
                    content: "Survoler le graphique avec la souris pour connaître l'entité géographique et la valeur associées à un élément du graphique",
                    placement: "left"
                }, {
                    title: "Graphiques",
                    element: ".cv-chartView",
                    content: "Double-cliquer sur une colonne pour déplacer la carte sur l'entité géographique",
                    placement: "left"
                }, {
                    title: "Graphiques",
                    element: ".cv-chartView",
                    content: "À noter que le graphique se met à jour automatiquement en fonction des entités géographiques sélectionnées",
                    placement: "left",
                    duration: 6000,
                    onShown: function(tour) {
                        var codes = ["711_001", "711_002", "711_003", "711_004", "711_005"];
                        var map = window.cartovista.externalInterface.map;
                        var mapController = window.cartovista.getMapController(map);
                        map.selectionLayer.selectFeatures(codes, false);
                        map.selectionLayer.getFeatures(map.selectionLayer._selection, function(result) {
                            mapController.zoomOnFeatures(result.features, map.selectionLayer);
                        });
                    }
                }, {
                    title: "Graphiques",
                    element: ".cv-chartView .cv-btnExport:visible",
                    content: "Exporter une image du graphique",
                    placement: "left"
                }],
                onTourStart: function() {
                    $(".cv-chartView .cv-btnExport").toggleClass("cv-fade")
                },
                onTourEnd: function() {
                    $(".cv-chartView .cv-btnExport:visible").toggleClass("cv-fade")
                }
            },
            "panelInfo": {
                steps: [{
                    title: "Information",
                    element: ".cv-btnToggleInfoView",
                    content: "Information : Afficher les informations associées aux entités de la carte questionnées avec l'outil Info",
                    placement: "left",
                    onShown: function(tour) {
                        var map = window.cartovista.externalInterface.map;
                        window.cartovista.getUIController(map).findInstance("infoView").activate();
                        $(".cv-infoView").addClass("cv-state-normal");
                        $(".cv-infoView").removeClass("cv-state-list");
                    }
                }, {
                    title: "Information",
                    element: ".cv-infoPanTool",
                    content: "Sélectionner l'outil Info et cliquer à l'endroit désiré sur la carte",
                    placement: "bottom",
                    onShown: function(tour) {
                        $(this.element).click();
                    }
                }, {
                    title: "Information",
                    element: undefined,
                    placement: undefined,
                    content: "Symbole indiquant l'emplacement pointé avec l'outil Info",
                    orphan: true,
                    onShown: function(tour) {
                        var map = window.cartovista.externalInterface.map;
                        var mapController = window.cartovista.getMapController(map);
                        var layer = map.getLayer("Cs_Franco_2");
                        layer.getFeatures(null, function(result) {
                            mapController.zoomOnFeatures([result.features[0]], 1000);
                            mapController.requestInfo(result.features[0].centroid.x, result.features[0].centroid.y);
                        });
                    }
                }, {
                    title: "Information",
                    element: ".cv-infoView .cv-view-normal",
                    content: "Noms des couches interrogées et ainsi que l'identifiant de l'entité géographique à l'emplacement sélectionné",
                    placement: "left"
                }, {
                    title: "Information",
                    element: ".cv-infoView .cv-feature:eq(0)",
                    content: "Cliquer sur un élément pour afficher la liste des informations qui y sont associées",
                    placement: "left",
                    onHide: function(tour) {
                        $(this.element).click();
                    }
                }, {
                    title: "Information",
                    element: "#-btnFeatureNavNext",
                    content: "Cliquer sur les flèches pour consulter les informations des autres entités interrogées",
                    placement: "bottom",
                    onShown: function(tour) {
                        $(".cv-infoView-featurenav").toggleClass("cv-fade");
                    },
                    onHide: function(tour) {
                        $(this.element).click();
                        $(".cv-infoView-featurenav").toggleClass("cv-fade");
                    }
                }, {
                    title: "Information",
                    element: ".cv-infoView .cv-btnCopy",
                    content: "Copier les données dans le presse-papier",
                    placement: "left",
                    onShown: function(tour) {
                        $(".cv-infoView .cv-btnCopy").toggleClass("cv-fade");
                    },
                    onHide: function(tour) {
                        $(".cv-infoView .cv-btnCopy").toggleClass("cv-fade");
                    }
                }],
                onTourStart: function() {
                    $(".cv-toolbar").css({
                        "opacity": "1",
                        "transition": "all 0 ease 0"
                    });
                },
                onTourEnd: function() {
                    $(".cv-toolbar").css({
                        "opacity": "",
                        "transition": ""
                    });
                    var map = window.cartovista.externalInterface.map;
                    window.cartovista.getMapController(map).resetMapExtent();
                }
            },
            "panelLegende": {
                steps: [{
                    title: "La légende",
                    element: ".cv-btnToggleLegendView",
                    content: "Légende : Afficher la légende de la carte",
                    placement: "left",
                    onShown: function(tour) {
                        var map = window.cartovista.externalInterface.map;
                        window.cartovista.getUIController(map).findInstance("legendView").activate();
                    }
                }, {
                    title: "La légende",
                    element: ".cv-legend-treeView ul:eq(0)",
                    content: "Consulter la légende de chacune des couches d\'information présentes sur la carte",
                    placement: "left"
                }, {
                    title: "La légende",
                    element: ".cv-btnExportLegend",
                    content: "Exporter une image de la légende",
                    placement: "left"
                }, ],
                onTourStart: function() {
                    $(".cv-btnExportLegend").toggleClass("cv-fade")
                },
                onTourEnd: function() {
                    $(".cv-btnExportLegend").toggleClass("cv-fade")
                }
            },
            "panelDonnees": {
                steps: [{
                    title: "Données",
                    element: ".cv-btnToggleDataView",
                    content: "Afficher le tableau de données complet. Le chiffre entre parenthèses correspond au nombre total d'entités",
                    placement: "top",
                    onShown: function(tour) {
                        var map = window.cartovista.externalInterface.map;
                        window.cartovista.getUIController(map).findInstance("dataView-allFeatures").activate();
                    }
                }, {
                    title: "Données",
                    element: "#dataView-allFeatures .cv-ddlLayerList:first",
                    content: "Alterner entre les différentes couches d'information disponibles",
                    placement: "top",
                    onShown: function(tour) {
                        $(this.element).click();
                    },
                    onHide: function(tour) {
                        $(this.element).click();
                    }
                }, {
                    title: "Données",
                    element: "#dataView-allFeatures .k-grid-header .k-link:first",
                    content: "Cliquer sur l'entête des colonnes pour trier les données par ordre ascendant ou descendant",
                    placement: "top",
                    onShown: function(tour) {
                        $(this.element).click();
                    }
                }, {
                    title: "Données",
                    element: "#dataView-allFeatures .k-grid-header .k-grid-filter:first",
                    content: "Appliquer différents filtres sur les données d'une colonne",
                    placement: "top",
                    onShown: function(tour) {
                        $(this.element).click();
                    },
                    onHidden: function(tour) {
                        $(this.element).click();
                    }
                }, {
                    title: "Données",
                    element: "#dataView-allFeatures tr[role='row']:has('.cv-dataGridCell-labelLeft'):eq(4)",
                    content: "Cliquer sur une ligne pour sélectionner l'entité. Utiliser les touches Maj ou Ctrl pour faire une sélection multiple",
                    placement: "top",
                    onShown: function(tour) {
                        $(this.element).click();
                    }
                }, {
                    title: "Données",
                    element: "#dataView-allFeatures tr[role='row']:has('.cv-dataGridCell-labelLeft'):eq(4)",
                    content: "L'entité sélectionnée est surlignée en bleu",
                    placement: "top"
                }, {
                    title: "Données",
                    element: "#dataView-allFeatures tr[role='row']:has('.cv-dataGridCell-labelLeft'):eq(4)",
                    content: "Double-cliquer sur la ligne pour zoomer la carte sur l'entité",
                    placement: "top",
                    onShown: function(tour) {
                        for (var i=0; i<2; i++) {
                            $(this.element).click();
                        }
                    }
                }, {
                    title: "Données",
                    element: "#dataView-allFeatures .cv-btnCopy",
                    content: "Copier le tableau de données dans le presse-papier",
                    placement: "top",
                    onShown: function(tour) {
                        $(this.element).toggleClass("cv-fade");
                        $(this.element).click();
                    },
                    onHide: function(tour) {
                        $(this.element).toggleClass("cv-fade");
                    }
                }, {
                    title: "Données",
                    element: "[id='DataViewController (allFeatures)-btnExport']",
                    content: "Exporter le tableau de données en format Excel",
                    placement: "top",
                    onShown: function(tour) {
                        $(this.element).toggleClass("cv-fade");
                    },
                    onHide: function(tour) {
                        $(this.element).toggleClass("cv-fade");
                    }
                }, {
                    title: "Données",
                    element: ".cv-btnDataSelectionView",
                    content: "Afficher le tableau de données des entités sélectionnées seulement. Le chiffre entre parenthèses correspond au nombre d'entités sélectionnées",
                    placement: "top",
                    onShown: function(tour) {
                        if (!$("#dataView-selectedFeatures").hasClass("cv-panel-active")) {
                            $(this.element).click();
                        }
                    },
                }, {
                    title: "Données",
                    element: "#dataView-selectedFeatures",
                    content: "À noter que ce tableau se met automatiquement à jour en fonction des entités géographiques sélectionnées",
                    placement: "top",
                    duration: 6000
                }],
                onTourStart: function() {
                    if ($("#dataView-allFeatures").hasClass("cv-state-statistics")) {
                        $("#dataView-allFeatures").toggleClass("cv-state-statistics");
                    }
                    if ($("#dataView-selectedFeatures").hasClass("cv-state-statistics")) {
                        $("#dataView-selectedFeatures").toggleClass("cv-state-statistics");
                    }
                },
                onTourEnd: function() {
                    var map = window.cartovista.externalInterface.map;
                    window.cartovista.getUIController(map).findInstance("dataView-allFeatures").deactivate();
                    window.cartovista.getUIController(map).findInstance("dataView-selectedFeatures").deactivate();
                }
            }
    };

    for (var tour in config) {
        for (var i=0; i < config[tour].steps.length; i++) {
            config[tour].steps[i]["title"] = '<div class="row"><div class="col-md-10">' + config[tour].steps[i]["title"] + '</div><div class="col-md-2"><span class="pull-right">' + (i+1) + '/' + config[tour].steps.length + '</span></div></div>';
        }
    }

    return {
      "MODAL_HTML" : modalHtml,
      "TOURS_CONFIG" : config,
      "DURATION" : 6000,
      "THEMESET_ID" : "ThemeSet3"
    };

});
